import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { appConfigAPI } from './api';

// Shared state for the single App Store / Play Store review switch.
// Several places render it (header pill, dashboard, Settings,
// Auto-Publish); a window event keeps every mounted copy in sync.
const EVENT = 'nn:review-mode';

export function useReviewMode() {
  const [on, setOn] = useState(null); // null = loading
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let alive = true;
    appConfigAPI.get()
      .then((res) => {
        if (!alive) return;
        setOn(!!res.data?.app_review_mode);
      })
      .catch(() => alive && setOn(false));
    const onEvent = (e) => setOn(!!e.detail);
    window.addEventListener(EVENT, onEvent);
    return () => { alive = false; window.removeEventListener(EVENT, onEvent); };
  }, []);

  const setMode = useCallback(async (value) => {
    setSaving(true);
    try {
      const payload = { app_review_mode: value };
      const res = await appConfigAPI.update(payload);
      const next = !!res.data?.app_review_mode;
      setOn(next);
      window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
      toast.success(next
        ? 'Review mode ON — aggregation paused, aggregated articles hidden'
        : 'Review mode OFF — aggregation and aggregated articles restored');
      return next;
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to update review mode');
      return null;
    } finally {
      setSaving(false);
    }
  }, []);

  return { on, saving, setMode };
}

export const REVIEW_MODE_SUMMARY =
  'Stops all auto-publishing from external sources (including "Fetch latest now") and '
  + 'hides every aggregated article on the website and in the apps. App features '
  + '(Reels, Live, subscriptions) always stay visible. Manually written articles are unaffected.';
